import { Stack, Radio, NumberInput, Box, Alert, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

export default function OrderPaymentTab({
  paymentMethod,
  setPaymentMethod,
  monthlyInvoicingEnabled,
  dueDays,
  setDueDays,
  defaultDueDateDays,
  t,
  disabled = false,
}) {
  return (
    <Stack gap="md">
      {disabled && (
        <Alert icon={<IconInfoCircle size={16} aria-hidden="true" />} color="orange" variant="light" mb="md">
          <Text size="sm">{t('takeOrderEditingRunning', 'You are editing a running order. Payment method is fixed to monthly and cannot be changed.')}</Text>
        </Alert>
      )}
      <Radio.Group
        value={paymentMethod}
        onChange={setPaymentMethod}
        label={t('takeOrderPaymentMethod', 'Payment method')}
        required
        aria-required="true"
      >
        <Stack gap="xs" mt="xs">
          <Radio
            disabled={disabled}
            value="invoice"
            label={t('takeOrderMethodInvoice', 'Invoice')}
            description={t('takeOrderMethodInvoiceDesc', 'PDF invoice with QR bill. Payment due on the due date.')}
          />
          <Radio
            value="monthly"
            label={t('takeOrderMethodMonthly', 'Monthly invoice')}
            description={
              monthlyInvoicingEnabled
                ? t('takeOrderMethodMonthlyDesc', 'Rolled into the customer\u2019s monthly aggregated invoice.')
                : t('takeOrderMonthlyUnavailable', 'This customer is not on monthly invoicing. It will fall back to Invoice.')
            }
            disabled={disabled || !monthlyInvoicingEnabled}
          />
        </Stack>
      </Radio.Group>

      <Box>
        <NumberInput
          label={t('takeOrderDueInDays', 'Payment due in (days)')}
          description={t('takeOrderDueInDaysHint', 'Due date = order date + this many days (default {days}).', { days: defaultDueDateDays })}
          value={dueDays === '' || dueDays == null ? '' : Number(dueDays)}
          onChange={(val) => setDueDays(val === '' || val == null ? '' : String(val))}
          min={1}
          allowNegative={false}
          required
          aria-required="true"
          styles={{ input: { maxWidth: 260 } }}
        />
      </Box>
    </Stack>
  );
}
